export const DEALER_PROTECTED_ROUTES_CONFIG = {
  '/home/shopping': 'emulation.needDealerForShopping',
  '/home/remit': 'emulation.needDealerForRemit',
  '/home/claims': 'emulation.needDealerForClaims',
  '/home/history': 'emulation.needDealerForContractsHistory',
  '/home/contract-search': 'emulation.needDealerForContractSearch',
  '/home/archive': 'emulation.needDealerForContractsArchive',
} as const;

export class DealerRoutesRegistry {
  private static protectedRoutes = new Map<string, string>(
    Object.entries(DEALER_PROTECTED_ROUTES_CONFIG)
  );

  static isDealerProtectedRoute(route: string): boolean {
    return Array.from(this.protectedRoutes.keys()).some(protectedRoute => 
      route.startsWith(protectedRoute)
    );
  }

  static getReasonForRoute(route: string): string | undefined {
    const matchedRoute = Array.from(this.protectedRoutes.keys()).find(protectedRoute =>
      route.startsWith(protectedRoute)
    );

    return matchedRoute ? this.protectedRoutes.get(matchedRoute) : undefined;
  }

  static getProtectedRoutes(): string[] {
    return Array.from(this.protectedRoutes.keys());
  }
}
